<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="飞线样式" name="1" @mousedown.native="collapseMouseDown($event, '1')">
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <line-setting
            title="线条样式"
            :lineName.sync="lineType"
            :lineWidth.sync="lineWidth"
            :lineColor.sync="lineColor"
          />
          <slider-and-input
            class="mt16"
            :value.sync="lineCurveness"
            titlePosition="singleLine"
            title="曲度"
            :sliderMax="20"
            suffix="px"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="线特效" name="2" @mousedown.native="collapseMouseDown($event, '2')">
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <cx-check-box :value.sync="showEffect">显示线特效</cx-check-box>
          <div v-show="showEffect">
            <cx-select class="mt16" title="特效图标" :selectOptions="symbolType" :value.sync="symbol" />
            <cx-select class="mt16" title="特效方向" :selectOptions="symbolDirectionList" :value.sync="symbolDirection" />
            <slider-and-input class="mt16" :value.sync="symbolSize" title="特效大小" :sliderMax="20" suffix="px" />
            <slider-and-input class="mt16" :value.sync="period" title="特效速度" :sliderMax="20" suffix="px" />
            <slider-and-input class="mt16" :value.sync="trailLength" title="尾迹长度" :sliderMax="100" suffix="px" />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="文字设置" name="3" @mousedown.native="collapseMouseDown($event, '3')">
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <cx-check-box :value.sync="showLabel">显示文字</cx-check-box>
          <div v-show="showLabel">
            <cx-select class="mt16" title="特效图标" :selectOptions="positionType" :value.sync="position" />
            <text-setting-update
              class="mt16"
              :fontColor.sync="fontColor"
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
            />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: [],
      collapseActiveNames: ["1"],
      symbolType: [
        { label: "圆形", value: "circle" },
        { label: "矩形", value: "rect" },
        { label: "圆角矩形", value: "roundRect" },
        { label: "三角形", value: "triangle" },
        { label: "菱形", value: "diamond" },
        { label: "气球", value: "pin" },
        { label: "箭头", value: "arrow" }
      ],
      symbolDirectionList: [
        { label: "多个起点至一个终点", value: "converge" },
        { label: "一个起点至多个终点", value: "spread" },
      ],
      positionType: [
        { label: "开始", value: "start" },
        { label: "居中", value: "middle" },
        { label: "末尾", value: "end" }
      ]
    }
  },
  props: {
    options: Object
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    chartOption() {
      return this.options.chartOption
    },
    lineType: {
      get() {
        return this.chartOption.lines.lineStyle.type
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.lineStyle.type", false)
      }
    },
    lineWidth: {
      get() {
        return Number(this.chartOption.lines.lineStyle.width)
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.lineStyle.width", false)
      }
    },
    lineColor: {
      get() {
        return this.chartOption.lines.lineStyle.color
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.lineStyle.color", false)
      }
    },
    lineCurveness: {
      get() {
        return this.chartOption.lines.lineStyle.curveness * 10
      },
      set(val) {
        this.$changeOptionsEV(val / 10, "chartOption.lines.lineStyle.curveness", false)
      }
    },
    showEffect: {
      get() {
        return this.chartOption.lines.effect.show
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.effect.show", false)
      }
    },
    symbolSize: {
      get() {
        return this.chartOption.lines.effect.symbolSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.effect.symbolSize", false)
      }
    },
    period: {
      get() {
        return this.chartOption.lines.effect.period
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.effect.period", false)
      }
    },
    symbol: {
      get() {
        return this.chartOption.lines.effect.symbol
      },
      set(val) {
        this.period++
        setImmediate(() => this.period--)
        this.$changeOptionsEV(val, "chartOption.lines.effect.symbol", false)
      }
    },
    symbolDirection: {
      get() {
        return this.chartOption.lines.effect.symbolDirection || "converge"
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.effect.symbolDirection", false)
      }
    },
    trailLength: {
      get() {
        return parseInt(this.chartOption.lines.effect.trailLength * 100)
      },
      set(val) {
        this.$changeOptionsEV((val / 100).toFixed(3), "chartOption.lines.effect.trailLength", false)
      }
    },
    showLabel: {
      get() {
        return this.chartOption.lines.label.show
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.label.show", false)
      }
    },
    position: {
      get() {
        return this.chartOption.lines.label.position
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.label.position", false)
      }
    },
    fontColor: {
      get() {
        return this.chartOption.lines.label.fontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.label.fontColor", false)
      }
    },
    fontFamily: {
      get() {
        return this.chartOption.lines.label.fontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.label.fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.chartOption.lines.label.fontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.label.fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.chartOption.lines.label.fontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.lines.label.fontWeight", false)
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    }
  }
}
</script>

<style scoped>
.top_span {
  margin-right: 16px;
}
</style>
